module.exports = __webpack_public_path__ + "static/img/newimg4.d39caeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg4.png
// module id = 3PvW
// module chunks = 1